import { useEffect, useRef } from "react";

export function PopupModal({ children, styleOfModal, closeModal, closeOnEscape = false }) {
  const modalRef = useRef(null);

  const handleClickOutside = event => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [closeModal]);

  useEffect(() => {
    if (!closeOnEscape) {
      return undefined;
    }
    const onKeyDown = event => {
      if (event.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [closeModal, closeOnEscape]);

  return (
    <div style={styleOfModal} ref={modalRef}>
      {children}
    </div>
  );
}
